module.exports = __webpack_public_path__ + "static/media/scanImage.d7d6a666.svg";